import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminComponent } from './admin.component';
import { AdminRoutingModule } from './admin-routing.module';
import { FlexLayoutModule } from '@Common/widgets/flex-layout/flex-layout.module';
import { MatAngularModule } from '@Common/mat-angular.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModuleP8 } from '@Common/common-p8.module';
import { UsersComponent } from './users/users.component';
import {ConfigurationComponent} from './users/configuration/configuration.component';
import {CommonDematModule} from 'app/demat/common/common.module';
import { EntitesComponent } from './entites/entites.component';


@NgModule({
    imports: [
        CommonModule,
        FlexLayoutModule,
        MatAngularModule,
        FormsModule,
        ReactiveFormsModule,
        CommonModuleP8,
        AdminRoutingModule,
        CommonDematModule,
    ],
    declarations: [
        AdminComponent,
        UsersComponent,
        ConfigurationComponent,
        EntitesComponent,
    ],
    schemas: [NO_ERRORS_SCHEMA],
    exports: [
        AdminComponent
    ]
})
export class AdminModule { }
